
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-3118cd30&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EmptyCart.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmptyCart.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-3118cd30!../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmptyCart.vue"),
  /* scopeId */
  "data-v-3118cd30",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/EmptyCart.vue
// module id = 367
// module chunks = 0